class BricksReservation {
    id;
    trader;
    status;
    bricksOnSale;
    numberOfBricks;
    averagePricePerBrick;
    revolvingFundAmountPerBrick;
    averagePricePerBrickWithRevolvingFund;
    subtotalAmount;
    totalRevolvingFundAmount;
    totalAmount;
    expiresAt;
    constructor(data) {
        this.id = data.id;
        this.trader = data.trader;
        this.status = data.status;
        this.bricksOnSale = data.bricksOnSale;
        this.numberOfBricks = data.numberOfBricks;
        this.averagePricePerBrick = data.averagePricePerBrick;
        this.revolvingFundAmountPerBrick = data.revolvingFundAmountPerBrick;
        this.averagePricePerBrickWithRevolvingFund = data.averagePricePerBrickWithRevolvingFund;
        this.subtotalAmount = data.subtotalAmount;
        this.totalRevolvingFundAmount = data.totalRevolvingFundAmount;
        this.totalAmount = data.totalAmount;
        this.expiresAt = data.expiresAt;
    }
}
export default BricksReservation;
